import React from 'react';

const TranslatableField = ({ label, name, value, onChange, isTextarea = false, required = true, disabled = false }) => {
  const supportedLangs = ['en', 'es', 'fr', 'ru'];
  // Check if value is a map (object) or a simple string
  const isMap = typeof value === 'object' && value !== null && !Array.isArray(value);

  const handleValueChange = (lang, newValue) => {
    if (isMap) {
      onChange({ target: { name, value: { ...value, [lang]: newValue } } });
    } else {
      onChange({ target: { name, value: newValue } });
    }
  };

  const addTranslation = (lang) => {
    const newValue = isMap ? { ...value } : { en: value || '' };
    newValue[lang] = '';
    onChange({ target: { name, value: newValue } });
  };

  const removeTranslation = (lang) => {
    const newValue = { ...value };
    delete newValue[lang];
    const keys = Object.keys(newValue);
    
    if (keys.length === 1) {
      // Collapse back to string if only one remains
      onChange({ target: { name, value: newValue[keys[0]] || '' } });
    } else if (keys.length === 0) {
      onChange({ target: { name, value: '' } });
    } else {
      onChange({ target: { name, value: newValue } });
    }
  };

  const unusedLangs = supportedLangs.filter(l => {
    if (isMap) return !value.hasOwnProperty(l);
    return l !== 'en';
  });

  return (
    <div className="form-group" style={{ marginBottom: '15px' }}>
      <label style={{ display: 'block', marginBottom: '5px', fontWeight: 'bold' }}>{label}:</label>
      
      {!isMap ? (
        <div style={{ display: 'flex', gap: '10px' }}>
          {isTextarea ? (
            <textarea 
              name={name} 
              value={value || ''} 
              onChange={onChange} 
              rows={3} 
              required={required}
              disabled={disabled}
              style={{ width: '100%', padding: '8px', backgroundColor: disabled ? '#f5f5f5' : 'white' }} 
            />
          ) : (
            <input 
              name={name} 
              value={value || ''} 
              onChange={onChange} 
              required={required}
              disabled={disabled}
              style={{ width: '100%', padding: '8px', backgroundColor: disabled ? '#f5f5f5' : 'white' }} 
            />
          )}
        </div>
      ) : (
        <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
          {Object.keys(value).map(lang => (
            <div key={lang} style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
              <span style={{ minWidth: '30px', fontWeight: 'bold', textTransform: 'uppercase' }}>{lang}:</span>
              {isTextarea ? (
                <textarea 
                  value={value[lang]} 
                  onChange={(e) => handleValueChange(lang, e.target.value)} 
                  rows={2} 
                  required={required}
                  disabled={disabled}
                  style={{ flex: 1, padding: '8px', backgroundColor: disabled ? '#f5f5f5' : 'white' }} 
                />
              ) : (
                <input 
                  value={value[lang]} 
                  onChange={(e) => handleValueChange(lang, e.target.value)} 
                  required={required}
                  disabled={disabled}
                  style={{ flex: 1, padding: '8px', backgroundColor: disabled ? '#f5f5f5' : 'white' }} 
                />
              )}
              <button 
                type="button" 
                onClick={() => removeTranslation(lang)} 
                disabled={disabled}
                style={{ padding: '4px 8px', backgroundColor: '#dc3545', color: 'white', border: 'none', borderRadius: '4px', cursor: 'pointer', opacity: disabled ? 0.6 : 1 }}
              >
                Delete
              </button>
            </div>
          ))}
        </div>
      )}
      
      {unusedLangs.length > 0 && (
        <div style={{ marginTop: '5px' }}>
          <span style={{ fontSize: '0.8rem', marginRight: '10px' }}>Add translation:</span>
          {unusedLangs.map(lang => (
            <button
              key={lang}
              type="button"
              onClick={() => addTranslation(lang)}
              disabled={disabled}
              style={{ padding: '2px 6px', fontSize: '0.75rem', marginRight: '5px', cursor: 'pointer', border: '1px solid #ccc', borderRadius: '4px', backgroundColor: '#f8f9fa', color: '#333', opacity: disabled ? 0.6 : 1 }}
            >
              {lang.toUpperCase()}
            </button>
          ))}
        </div>
      )}
    </div>
  );
};

export default TranslatableField;